import React from 'react';
import {Helmet} from 'react-helmet';
import {Redirect, Router} from '@reach/router';
import {StripeProvider} from 'react-stripe-elements';

import {Frame, ProtectedRoute} from './components';
import {useAuth} from './context';
import {useStripe} from './hooks';
import {AccountInvitation, Memberships, Plans, Settings} from './sections';

export function App() {
  const {loggedIn} = useAuth();
  const stripe = useStripe();

  return (
    <>
      <Helmet titleTemplate="Plum | %s" defaultTitle="Plum" />

      <StripeProvider stripe={stripe}>
        <Frame visible={loggedIn}>
          <Router>
            <AccountInvitation path="/account_invitation" />

            <ProtectedRoute
              component={() => <Redirect noThrow to="/memberships" />}
              path="/"
            />
            <ProtectedRoute component={Memberships} path="/memberships/*" />
            <ProtectedRoute component={Plans} path="/plans/*" />
            <ProtectedRoute component={Settings} path="/settings/*" />
          </Router>
        </Frame>
      </StripeProvider>
    </>
  );
}
